export enum AnimatedImages {
  PENCIL_SKETCH = 'PENCIL_SKETCH',
  COMETA = 'COMETA',
  CLOCK = 'CLOCK',
  KEY = 'KEY',
  UMBRELLA = 'UMBRELLA',
  SUN = 'SUN',
  LUPA = 'LUPA',
  AIM = 'AIM',
  VOICE = 'VOICE',
  CLOUD = 'CLOUD',
  SCALES_BRAIN = 'SCALES_BRAIN',
  SCALES_HEART = 'SCALES_HEART',
  HEART_BRAIN_EQUAL = 'HEART_BRAIN_EQUAL',
  COMPASS = 'COMPASS',
  HELLO = 'HELLO',
  CLARITY = 'CLARITY',
  COMMUNICATION = 'COMMUNICATION',
  FLOWER = 'FLOWER',
  SCRATCH = 'SCRATCH',
  MAP = 'MAP',
  SCAN = 'SCAN',
  SCAN_STREET = 'SCAN_STREET',
  GIFT = 'GIFT',
  MEDITATION = 'MEDITATION',
  READING = 'READING',
  PRACTICES = 'PRACTICES',
  NATAL_CHART = 'NATAL_CHART',
  BIRTH_CHART = 'BIRTH_CHART',
  ZODIAC_BACKGROUND = 'ZODIAC_BACKGROUND',
  LOAD_36 = 'LOAD_36',
  LOAD_70 = 'LOAD_70',
  LOAD_100 = 'LOAD_100',
}
